module.exports = __webpack_public_path__ + "img/card-btn.d72a1bf2.png";